import { dbMagicBall as db } from '../../firebase';
import { getBackendError } from 'common/utils';

const userMapper = (documentSnapshot) => {
  const { cntPushNotification, dateCreated, dateUpdated, language, deviceToken, platform } = documentSnapshot.data();

  return {
    uid: documentSnapshot.id,
    cntPushNotification,
    dateCreated,
    dateUpdated,
    language: language ? language : null,
    deviceToken,
    platform: platform ? platform : '-'
  };
};

const userListMapper = (docs) => {
  return docs.map((documentSnapshot) => userMapper(documentSnapshot));
};

export const getUsersList = async () => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .get()
      .then((querySnapshot) => resolve(userListMapper(querySnapshot.docs)))
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const getUsersListByCntPushNotification = async (cnt) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .where('cntPushNotification', '==',  cnt)
      .get()
      .then((querySnapshot) => resolve(userListMapper(querySnapshot.docs)))
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const getUsersListByLang = async (lang) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .where('language', '==', lang)
      .get()
      .then((querySnapshot) => resolve(userListMapper(querySnapshot.docs)))
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const getUserItem = async (id) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .get()
      .then((querySnapshot) => {
        const { cntPushNotification, dateCreated, dateUpdated, language, deviceToken } = querySnapshot.data();
       
        const obj = {
          uid: deviceToken,
          cntPushNotification,
          dateCreated,
          dateUpdated,
          language: language ? language : null,
          deviceToken,
        };
        
        resolve(obj);
      })
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateCntPushNotification = (id, cntPushNotification) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .update({
        cntPushNotification,
        dateUpdated: new Date().getTime()
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const deleteUserItem = async (id) => {
  return new Promise((resolve, reject) => {
    db
      .collection('user')
      .doc(id)
      .delete()
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};
